/** Keep in sync with backend App\Support\TeamAssistantFilePolicy */
export const TEAM_ASSISTANT_UPLOAD_ACCEPT =
  '.pdf,.txt,.md,.markdown,.html,.htm,.json,.doc,.docx,.rtf,.odt,.ppt,.pptx,.xls,.xlsx,.csv,.tsv,.tex,.png,.jpg,.jpeg,.gif,.webp';

/** Max files staged in the composer before send (chat stream). */
export const MAX_TEAM_ASSISTANT_COMPOSER_ATTACHMENTS = 10;
